<template>
  <div class="order">
    <van-nav-bar title="我的订单" fixed />
    <van-tabs sticky offset-top="46px" v-model="curTab" @change="handleTabChange" animated swipeable>
      <van-tab v-for="tab in tabs" :title="tab.name" :key="tab.value">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            class="order-list"
            v-model="loading"
            :immediate-check="false"
            :finished="finished"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <van-cell class="order-item" :border="false" v-for="item in list || []" :key="item.id" @click="toDetail(item)">
              <div class="flex-row-between">
                <div class="font-12 color-gray">{{ item.update_time | dateFormat }}</div>
                <van-tag class="font-12 line-height-12" :type="item.status ? 'success' : 'warning'" plain>{{ item.status_desc }}</van-tag>
              </div>
              <div class="flex-row-between">
                <div class="font-14 font-weight-blod">{{ item.car_brand_name }} {{ item.product_time }} {{ item.displacement }}L</div>
                <div class="font-12 color-gray">{{ item.vin_code }}</div>
              </div>
              <div class="flex-row-between">
                <div class="font-12 ellipsis-line">{{ item.detailPartsName || '-' }}</div>
              </div>
              <div class="flex-row-between">
                <div class="font-12 color-gray">询单：{{ item.quote_order_no || '-' }}</div>
                <div class="font-12 color-gray">订单：{{ item.order_no || '-' }}</div>
              </div>
              <div class="flex-row-between">
                <div class="font-12 color-gray">{{ item.corporation_name || '-' }}</div>
              </div>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { queryOrderList } from '@/api/order'
import { debounce } from '@/utils'
export default {
  name: 'Order',
  data() {
    return {
      tabs: [
        {
          name: '全部',
          value: null
        },
        {
          name: '待付款',
          value: 0
        },
        {
          name: '待发货',
          value: 1
        },
        {
          name: '待收货',
          value: 2
        },
        {
          name: '已完成',
          value: 3
        },
        {
          name: '已取消',
          value: 4
        },
      ],
      curTab: 0,
      list: [],
      loading: false,
      finished: false,
      error: false,
      refreshing: false,
      page_dto: {
        pagination: 0,
        page_size: 20
      }
    }
  },
  created() {
    this.onRefresh()
  },
  methods: {
    handleTabChange() {
      this.onRefresh()
    },
    async search() {
      this.loading = true
      const status = (this.curTab === 0) ? null : this.curTab -1
      const params = {
        status,
        page_dto: this.page_dto
      }
      const { success, model, msg } = await queryOrderList(params).catch(() => {
        this.loading = false
        this.error = true
        this.refreshing = false
        return []
      })
      this.loading = false

      if (!success) {
        this.$toast(msg || '请求失败')
        return []
      }
      if (!model) {
        return []
      }
      const innerModel = model.model
      let data = []

      if (!Array.isArray(innerModel)) {
        data = []
      } else {
        data = innerModel
      }

      data = data.map(item => {
        item.detailPartsName = Array.isArray(item.detail_parts_alias_list) ? item.detail_parts_alias_list.join('、') : ''
        return item
      })

      return data
    },

    // 下拉刷新
    async onRefresh() {
      this.page_dto.pagination = 0
      const data = await this.search()
      this.list = data || []
      this.loading = false
      this.refreshing = false
      if (this.list.length < this.page_dto.page_size) {
        this.finished = true
      } else {
        this.page_dto.pagination++
      }
    },

    // 上拉加载
    onLoad: debounce(async function() {
      if (this.loading) return
      
      const data = await this.search()
      this.list = this.list.concat(data)

      if (data.length < this.page_dto.page_size) {
        this.finished = true
      } else {
        this.page_dto.pagination++
      }
    }, 100),
    toDetail(item) {
      this.$router.push({
        name: 'OrderDetails',
        query: {
          id: item.id.toString(),
          third_quote_id: item.third_quote_id.toString()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.order {
  background-color: #f7f7f7;
  box-sizing: border-box;
  // padding: 10px;
  height: 100%;
  .order-list {
    padding: 0 10px;
    padding-top: 10px;
    .order-item {
      margin-top: 10px;
      border-radius: 10px;
      &:nth-child(1) {
        margin-top: 0;
      }
    }
  }
}
</style>